/**
 * Javascript Map to MFC APP CSS Variables
 * If you add to public/static/css/palette.css please update this mapping file :)
 */
export const palette = {
    greenMFC: 'var(--green-mfc)',
    greenMFCDark: 'var(--green-mfc-dark)',
    greyMFC: 'var(--grey-mfc)',
    orangeMFC: 'var(--orange-mfc)',
    commonBlack: '#000',
    commonWhite: '#FFF',
    activeGreen: 'var(--active-green)',
    inactiveGrey: 'var(--inactive-grey)',
    disabledGrey: 'var(--disabled-grey)',
    contrastText: 'var(--contrast-text)',
    contrastIcons: 'var(--contrast-icons)',
    dimContrastIcons: 'var(--dim-contrast-icons)',
    disabledIcons: 'var(--disabled-icons)',
    background: 'var(--background)',
    backgroundLightGray: 'var(--background-light-gray)',
    backgroundLightGray2: 'var(--background-light-gray-2)',
    backgroundReverse: 'var(--background-reverse)',
    backgroundPaper: 'var(--background-paper)',
    backgroundRaised: 'var(--background-raised)',
    pinnedRoomBackground: 'var(--pinned-background)',
    pinnedChatBackground: 'var(--pinned-chat)',
    backgroundGrid: 'var(--grid-background)',
    layerShadow: 'var(--box-shadow)',
    layerSecondaryShadow: 'var(--box-secondary-shadow)',
    layerBorder: 'var(--layer-border)', // rename this
    layerLightBorder: 'var(--layer-light-border)',
    primary: 'var(--primary)',
    primaryLight: 'var(--primary-light)',
    primaryIcons: 'var(--primary-icons)',
    secondary: 'var(--secondary)',
    missMFCGold: 'var(--miss-mfc-gold)',
    missMFCSilver: 'var(--miss-mfc-silver)',
    missMFCBronze: 'var(--miss-mfc-bronze)',
    drag: 'var(--drag)',
    displayModeDivider: 'var(--display-mode-divider)',
    floatingToolbarBackground: 'var(--floating-toolbar-background)',
    floatingToolbarBackgroundLight: 'var(--floating-toolbar-background-light)',
    floatingToolbarDivider: 'var(--floating-toolbar-divider)',
    listItemBorder: 'var(--list-item-border)',
    listItemBoxShadow: 'var(--list-item-box-shadow)',
    badgeBookmark: 'var(--badge-bookmark)',
    badgeFriend: 'var(--badge-friend)',
    badgePopular: 'var(--badge-popular)',
    badgeTrending: 'var(--badge-trending)',
    badgeRecentlyVisited: 'var(--badge-recently-visited)',
    badgeNewModel: 'var(--badge-new-model)',
    informationText: 'var(--information-text)',
    informationBackground: 'var(--information-background)',
    guestWarningAlertBackground: 'var(--guest-warning-alert-background)',
    mfcNewItemBackground: 'var(--mfc-new-item-background)',
    mfcWarning: 'var(--mfc-warning)',
    mfcWarningBackground: 'var(--mfc-warning-background)',
    mfcAlertWarning: 'var(--mfc-alert-warning)',
    mfcAlertWarningBackground: 'var(--mfc-alert-warning-background)',
    mfcAlertSuccess: 'var(--mfc-alert-success)',
    mfcAlertSuccessBackground: 'var(--mfc-alert-success-background)',
    mfcAlertError: 'var(--mfc-alert-error)',
    mfcAlertErrorBackground: 'var(--mfc-alert-error-background)',
    mfcAlertInfo: 'var(--mfc-alert-info)',
    mfcAlertInfoBackground: 'var(--mfc-alert-info-background)',
    videoBackground: 'var(--video-background)',
    highlightBookmarkBorder: 'var(--highlight-bookmark-border)',
    highlightFriendBorder: 'var(--highlight-friend-border)',
    highlightActiveRoom: 'var(--highlight-active-room-border)',
    hightlightPopularRoomsborder: 'var(--highlight-popular-rooms-border)',
    hightlightTrendingRoomsborder: 'var(--highlight-trending-rooms-border)',
    hightlightRecentlyVisitedborder:
        'var(--highlight-recently-visited-rooms-border)',
    priorMissMfcCrownIcon: 'var(--miss-mfc-prior-winner-crown-icon)',
    active: 'var(--active)',
    avatarBadgeOffline: 'var(--avatar-badge-offline)',
    avatarBadgeOnline: 'var(--avatar-badge-online)',
    avatarBadgeHover: 'var(--avatar-badge-hover)',
    avatarFallbackUrl: 'var(--avatar-fallback-url)',
    avatarFallbackBackground: 'var(--avatar-fallback-background)',
    avatarFallbackBackgroundGrey: 'var(--avatar-fallback-background-grey)',
    avatarFallbackBoxShadow: 'var(--avatar-fallback-box-shadow)',
    monochromeFilter: 'var(--monochrome-filter)',
    buttonBackground: 'var(--button-background)',
    buttonOutlinedText: 'var(--button-outlined-text)',
    buttonPrimaryBorder: 'var(--button-primary-border)',
    buttonBorder: 'var(--button-border)',
    radioHover: 'var(--radio-hover)',
    drawerHeader: 'var(--drawer-header)',
    drawerBackground: 'var(--drawer-background)',
    drawerDivider: 'var(--drawer-divider)',
    drawerLabel: 'var(--drawer-label)',
    dialogButtonShadows: 'var(--dialog-button-shadow)',
    dialogContrastBackground: 'var(--dialog-contrast-background)',
    fullWindowChatBackground: 'var(--full-window-chat-background)',
    fullWindowComposeBackground: 'var(--full-window-compose-background)',
    imagesBackground: 'var(--images-background)',
    imagesMonochromeFilter: 'var(--images-monochrome-filter)',
    paragraphMain: 'var(--paragraph-main)',
    paragraphLight: 'var(--paragraph-light)',
    headerBackground: 'var(--header-background)',
    headerText: 'var(--header-text)',
    headerTokens: 'var(--header-tokens)',
    navBackground: 'var(--nav-background)',
    navButton: 'var(--nav-button)',
    topicButtonBackground: 'var(--topic-button-background)',
    tagsBackground: 'var(--tags-background)',
    tagsColor: 'var(--tags-color)',
    tagsBorder: 'var(--tags-border)',
    overlayFilterDropShadow: 'var(--overlay-filter-drop-shadow)',
    overlayTip: 'var(--overlay-tip)',
    overlayTipBackground: 'var(--overlay-tip-background)',
    systemMessageBackground: 'var(--system-message-background)',
    systemMessageColor: 'var(--system-message-color)',
    systemMessageLink: 'var(--system-message-link)',
    chatDivider: 'var(--chat-divider)',
    chatPmBubbleBackgroundFullWindow:
        'var(--chat-pmBubbleBackgroundFullWindow)',
    chatPmBubbleBackgroundMeFullWindow:
        'var(--chat-pmBubbleBackgroundMeFullWindow)',
    chatPmBubbleText: 'var(--chat-pmBubbleText)',
    chatTip: 'var(--chat-tip)',
    chatTipBackground: 'var(--chat-tipBackground)',
    chatclubEmojiBackground: 'var(--chat-clubEmojiBackground)',
    chatInlinePmBackground: 'var(--chat-inlinePmBackground)',
    chatInlinePmBackgroundMe: 'var(--chat-inlinePmBackgroundMe)',
    chatBackground: 'var(--chat-background)',
    chatSend: 'var(--chat-send)',
    chatSystemMessage: 'var(--chat-system-message)',
    floatingActionButtonBackground: 'var(--floating-action-button-background)',
    floatingActionButtonHover: 'var(--floating-action-button-hover)',
    notificationRed: 'var(--notification-red)',
    newsHeaderBackground: 'var(--news-header-background)',
    newsDisabledIcon: 'var(--disabled-news-icon)',
    rowAlternate: 'var(--row-alternate)',
    statusMessage: 'var(--status-message)',

    activeHover: 'var(--active-hover)',
    standardText: 'var(--standard-text)',
    primaryText: 'var(--primary-text)',
    secondaryText: 'var(--secondary-text)',
    disabledText: 'var(--disabled-text)',

    muiBlue50: 'var(--mui-blue-50)',
    muiBlue800: 'var(--mui-blue-800)',
    muiLtGreen50: 'var(--mui-ltgreen-50)',
    muiGreen800: 'var(--mui-green-800)',
    muiRed800: 'var(--mui-red-800)',
    muiYellow50: 'var(--mui-yellow-50)',
    muiYellow800: 'var(--mui-yellow-800)',

    colorSchemeSwitchTrack: 'var(--color-scheme-switch-track)',

    checkboxOptionColor: 'var(--checkbox-option-color)',

    rowSelectedBackground: 'var(--row-selected-background)',

    greenLink: 'var(--green-link)',
    orangeHover: 'var(--orange-hover)',

    smGreenChange: 'var(--green-change)',
    smRedChange: 'var(--red-change)',
}
